'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import { Tabs, TabsContent, TabsList, TabsTrigger } from '@eliadmin/core/src/components/ui/tabs';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import { useRouter } from 'next/navigation';
import { useState } from 'react';

function generateSlug(name: string) {
  const from = 'čćđšžČĆĐŠŽňŇáäčďéěíĺľňóôöőřšťúůüűýžÁÄČĎÉĚÍĹĽŇÓÔÖŐŘŠŤÚŮÜŰÝŽ';
  const to = 'ccdszCCDSZnNaacdeeillnoooorstuuuuyzAACDEEILLNOOOORSTUUUUYZ';

  let slug = name
    .toLowerCase()
    .split('')
    .map(letter => {
      const i = from.indexOf(letter);
      return i > -1 ? to[i] : letter;
    })
    .join('');

  slug = slug.replace(/[\s\W-]+/g, '-'); // Replace spaces and non-word chars with hyphens

  return slug;
}

export const MediaContent = ({ data, categories }: { data: any; categories: any }) => {
  const [selectedCategory, setSelectedCategory] = useState(categories[0]);
  const router = useRouter();

  const filteredTab = data.filter((item: any) =>
    item.fields.find(
      (field: any) =>
        field.field.type === 'multiselect' &&
        field.values.find((value: any) => value.name === selectedCategory),
    ),
  );

  return (
    <>
      <Tabs
        onValueChange={value => setSelectedCategory(value)}
        defaultValue={selectedCategory}
        className={cn('', 'ea-media-content__tabs')}
      >
        <TabsList className={cn('', 'ea-media-content__tabs-list')}>
          {categories.map((category: any) => (
            <TabsTrigger
              key={category}
              value={category}
              className={cn('', 'ea-media-content__tabs-trigger')}
            >
              {category}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value={selectedCategory} className={cn('', 'ea-media-content__tabs-content')}>
          {filteredTab.map((item: any) => {
            const mainImage = item.fields.find((field: any) => field.field.type === 'image')?.image;
            const slug = generateSlug(item.name);

            return (
              <div
                key={item.id}
                className={cn('', 'ea-media-content__content')}
                onClick={() => router.push(`/media/${slug}`)}
              >
                <div className={cn('', 'ea-media-overlay')} />
                <Image
                  src={mainImage?.url || '/images/placeholder.png'}
                  alt={resolveImageAlt(mainImage, 'Main Image')}
                  sizes="25vw"
                  className={cn('', 'ea-media-content__item-image')}
                  fill
                />
                <div className={cn('', 'ea-media-content__item-name')}>{item.name}</div>
              </div>
            );
          })}
        </TabsContent>
      </Tabs>
    </>
  );
};
